module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-layout.json
// module id = 324
// module chunks = 60335399758886 278322306582297